<template>
  <div :class="cssClass || 'inline-flex'">
    <a
      ref="btnRef"
      class="block"
      :class="{
        'cursor-not-allowed': notAllowed,
        'cursor-pointer': !notAllowed,
      }"
      @mouseover="showPopper"
      @mouseleave="hidePopper()"
    >
      <slot>
        <i class="fa-solid fa-circle-question mx-2 text-blueDianne/50"></i>
      </slot>
    </a>
    <div
      ref="popoverRef"
      class="bg-black/90 text-sm text-white absolute z-50 py-2 px-4 list-none text-left rounded-lg shadow-lg min-w-48"
      :class="{
        hidden: !popoverShow,
        block: popoverShow,
      }"
    >
      <div class="font-normal normal-case">
        <slot name="content"><span v-html="text"></span></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  props: {
    text: String,
    cssClass: String,
    placement: String,
    notAllowed: Boolean,
  },
  data() {
    return {
      popoverShow: false,
      popper: null,
    };
  },
  beforeUnmount() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    showPopper() {
      this.popoverShow = true;
      this.$nextTick(() => {
        if (!this.popper) {
          this.popper = createPopper(this.$refs.btnRef, this.$refs.popoverRef, {
            placement: this.placement || "right",
          });
        }
      });
    },
    hidePopper() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
      this.popoverShow = false;
    },
  },
};
</script>
